import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AlertDetailsComponent } from './alert-details.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { TitleBtnModule } from '../../../shared/components/title-btn/title-btn.module';
import { MatExpansionModule } from '@angular/material';
import { AlertCommentAddModule } from './comment/add/alert-comment-add.module';
import { AlertCommentDetailsModule } from './comment/details/alert-comment-details.module';
import { DecourseCommentAddModule } from '../../decourse/details/comment/add/decourse-comment-add.module';

@NgModule({
  declarations: [AlertDetailsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    TitleBtnModule,
    MatExpansionModule,
    AlertCommentAddModule,
    AlertCommentDetailsModule,
    DecourseCommentAddModule
  ],
  exports: [AlertDetailsComponent]
})
export class AlertDetailsModule { }
